import React from 'react'
import { TimelineUserBlock } from '@common/Timeline'
import { AuditResult } from '@core/entities/audit/AuditResult'
import { openInNewTab } from 'webapp/utils'
import { PageUrls } from '@core/page-urls'

type ComponentProps = {
  auditResult: AuditResult
}

export const TimelineUserBlocks: React.FC<ComponentProps> = ({
  auditResult,
}) => {
  return (
    <>
      {auditResult.projectUser && (
        <TimelineUserBlock
          user={auditResult.projectUser}
          onEdit={() => {
            openInNewTab(
              PageUrls.organisationUserProfile({
                organisationId: auditResult?.organisation?.id,
                userId: auditResult?.projectUser?.id,
                query: auditResult?.project?.id
                  ? { projectId: auditResult.project.id }
                  : undefined,
              }),
            )
          }}
        />
      )}
      {auditResult.organisationUser && (
        <TimelineUserBlock
          user={auditResult.organisationUser}
          onEdit={() => {
            openInNewTab(
              PageUrls.organisationUserProfile({
                organisationId: auditResult.organisation.id,
                userId: auditResult.organisationUser.id,
              }),
            )
          }}
        />
      )}
      {auditResult.showAppliedToUserBlock() && (
        <TimelineUserBlock user={auditResult.appliedToUser} />
      )}
    </>
  )
}
